<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>资金管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="isShowDetails = false">项目收支</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!isShowDetails">
      <section class="searchBox">
        <span class="addStyle">
          <a-button v-show="!showIsSearch" @click="showIsSearch = true"
            >显示更多</a-button
          >
          <a-button v-show="showIsSearch" @click="showIsSearch = false"
            >隐藏更多</a-button
          >
        </span>
        <span v-show="showIsSearch">
          <label>客户名称：</label>
          <a-select
            v-model="customer_id"
            style="min-width: 160px"
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option
              v-for="element in customerList"
              :key="element.id"
              :value="element.id"
              >{{ element.customer_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <label>行业：</label>
          <a-select
            placeholder="请选择行业类型"
            style="width: 100px"
            v-model="trade_id"
          >
            <a-select-option
              v-for="(item, i) in tradeList"
              :key="i"
              :value="item.id"
              >{{ item.trade_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <label>一级项目：</label>
          <a-select
            showSearch
            :filterOption="filterOption"
            v-model="selectedOneVal"
            @change="selectedOne"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListOne"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="isShowTwo">
          <label>省级项目：</label>
          <a-select
            v-model="selectedTwoVal"
            @change="selectedTwo"
            showSearch
            :filterOption="filterOption"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListTwo"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>项目：</label>
          <a-select
            v-model="selectedThreeVal"
            showSearch
            :filterOption="filterOption"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListThree"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <label>签约主体：</label>
          <a-select
            :maxTagCount="3"
            mode="multiple"
            v-model="company_id"
            style="min-width: 160px"
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option
              v-for="element in comList"
              :key="element.id"
              :value="element.id"
              >{{ element.company_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <a-select
            defaultValue="1"
            style="width: 120px; margin-right: 6px"
            v-model="time_type"
          >
            <a-select-option :value="1">费用所属日期</a-select-option>
            <a-select-option :value="2">开票日期</a-select-option>
            <a-select-option :value="3">入账日期</a-select-option>
            <a-select-option :value="4">出账日期</a-select-option>
          </a-select>
          <a-range-picker
            @change="changeDate"
            v-model="date"
            style="width: 200px"
            :placeholder="['开始时间', '结束时间']"
          />
        </span>

        <span>
          <label>状态：</label>
          <a-select style="width: 140px" v-model="status">
            <a-select-option :value="20">待项目负责人审核</a-select-option>
            <a-select-option :value="30">待财务审核</a-select-option>
            <a-select-option :value="40">待打款/待收款</a-select-option>
            <!-- <a-select-option :value="42">已入账/已出账</a-select-option> -->
            <a-select-option :value="50">结算完成</a-select-option>
          </a-select>
        </span>
        <span>
          <a-button @click="onReset" style="margin-right: 10px">重置</a-button>
          <a-button
            style="margin-right: 10px"
            type="primary"
            icon="search"
            @click="onSearch"
            >搜索</a-button
          >
          <a-button class="resetStyle" @click="downloadCost">
            <a-icon type="vertical-align-bottom" />下载
          </a-button>
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <ul class="titleStyle">
          <li v-for="item in thList" :key="item">
            {{ item }}
          </li>
        </ul>
        <ul class="contentStyle">
          <li>
            <p>合计</p>
            <p>&nbsp;</p>
            <p>
              {{
                count_data == ""
                  ? ""
                  : parseFloat(count_data.income_type_amount).toLocaleString()
              }}
            </p>
            <p>
              {{
                count_data == ""
                  ? ""
                  : parseFloat(count_data.in_total_amount).toLocaleString()
              }}
            </p>
            <p>
              {{
                count_data == ""
                  ? ""
                  : parseFloat(count_data.out_total_amount).toLocaleString()
              }}
            </p>
            <p>
              {{
                count_data == ""
                  ? ""
                  : parseFloat(count_data.profit_total_amount).toLocaleString()
              }}
            </p>
          </li>
          <li
            v-show="item.out_total_amount > 0 || item.in_total_amount > 0"
            v-for="(item, i) in data"
            :key="i"
            @click="selectedCost(item, i)"
          >
            <p>{{ item.project_name }}</p>
            <p>{{ item.customer_name }}</p>
            <p>{{ parseFloat(item.income_type_amount).toLocaleString() }}</p>
            <p>{{ parseFloat(item.in_total_amount).toLocaleString() }}</p>
            <p>
              {{ parseFloat(item.out_total_amount).toLocaleString() }}
            </p>
            <p>
              {{ parseFloat(item.profit_total_amount).toLocaleString() }}
            </p>
          </li>
        </ul>
      </section>
      <div class="paginationStyle paginationOtherStyle" :loading="loading">
        <div>
          <p>{{ "【&nbsp;" + proCostVal + "&nbsp;】项目费用明细" }}</p>
        </div>
        <!-- <div>
          <a-pagination
            showQuickJumper
            :defaultCurrent="page"
            :total="pagination.total"
            @change="onChange"
            :current="page"
          />
          <span>{{ "共：" + pagination.total + "条" }}</span>
        </div> -->
      </div>
      <section class="tableStyles costStyle">
        <ul class="titleStyle">
          <li v-for="item in costList" :key="item">
            {{ item }}
          </li>
        </ul>
        <ul class="contentStyle">
          <li
            v-show="dataCost.length > 0"
            v-for="(item, i) in dataCost"
            :key="i"
          >
            <p>{{ item.finance_date.substring(0, 10) }}</p>
            <p>
              <span v-if="item.type == 1">应收</span>
              <span v-else-if="item.type == 2">应付</span>
              <span v-else>未知</span>
            </p>
            <p>{{ item.pname + "-" + item.finance_type_name }}</p>
            <p>
              {{
                item.name.length > 10
                  ? item.name.substring(0, 10) + "..."
                  : item.name
              }}
            </p>
            <p>
              {{
                item.detail.length > 20
                  ? item.detail.substring(0, 20) + "..."
                  : item.detail
              }}
            </p>
            <p v-show="item.type == 1">
              {{
                "+" +
                  (Number(item.amount) + Number(item.pay_service)).toFixed(2)
              }}
            </p>
            <p v-show="item.type == 2">
              {{
                "-" +
                  (Number(item.amount) + Number(item.pay_service)).toFixed(2)
              }}
            </p>
            <p>
              <span v-show="item.status == 20">待项目负责人审核</span>
              <span v-show="item.status == 21">项目负责人驳回</span>
              <span v-show="item.status == 30">待财务审核</span>
              <span v-show="item.status == 31">财务驳回</span>
              <span v-show="item.type == 1 && item.status == 40">待收款</span>
              <span v-show="item.type == 2 && item.status == 40">待付款</span>
              <span v-show="item.status == 41">出纳驳回</span>
              <span v-show="item.type == 1 && item.status == 42">已入账</span>
              <span v-show="item.type == 2 && item.status == 42">已出账</span>
              <span v-show="item.status == 50">结算完成</span>
              <span v-show="item.status == 100">费用作废</span>
              <a
                @click="detailsPage(item)"
                style="margin-left:10px;color:#909399"
                >详情</a
              >
            </p>
          </li>
          <li style="text-align: center" v-show="dataCost == ''">
            暂无
          </li>
        </ul>
      </section>
      <!-- <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="pageVal"
          :total="paginationVal.total"
          @change="onChangeVal"
          :current="page"
        />
        <span>{{ "共：" + paginationVal.total + "条" }}</span>
      </div> -->
    </section>

    <!-- 详情 -->
    <costDetails
      v-on:hideInHandle="hideInHandle"
      v-show="isShowDetails"
      :detailsVal="detailsVal"
    />
    <!-- 详情 end -->
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";

import costDetails from "@/components/money/costDetails"; //详情
export default {
  components: {
    costDetails
  },
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      totalPage: Number,
      thList: ["项目", "客户名称", "开票收入", "项目收入", "项目支出", "利润"],
      type: "",
      proList: [],
      project_id: "",
      company_id: [],
      customer_id: "",
      comList: [],
      customerList: [],
      time_type: 1,
      proListOne: [],
      proListTwo: [],
      proListThree: [],
      isShowTwo: false,
      selectedOneVal: "",
      selectedTwoVal: "",
      selectedThreeVal: "",
      showIsSearch: false,
      costList: [
        "费用所属日期",
        "结算类型",
        "费用类型",
        "费用名称",
        "费用明细",
        "费用总金额",
        "状态"
      ],
      bgIndex: 0,
      proCostVal: "",
      dataCost: [],
      paginationVal: {},
      count_data: "",
      pageVal: 1,
      proCostID: "",
      status: "",
      start_date: "",
      end_date: "",
      date: null,
      tradeList: [],
      trade_id: "",
      pid: "",
      finance_type_id: "",
      isShowDetails: false,
      detailsVal: {}
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro(); //获取项目
    this.getCompany(); //获取公司
    this.getCustomer(); //获取客户
    this.getProOne(); //获取一级项目列表
    this.getTrade(); //获取行业
  },
  methods: {
    detailsPage(item) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.detailsVal = item;
      this.isShowDetails = true;
    },
    hideInHandle() {
      this.isShowDetails = false;
      this.reload();
    },
    selectedPID(id) {
      this.finance_type_id = "";
      this.getType(id); //获取费用类型
    },
    getTrade() {
      let url = this.httpsBasic.url + this.httpsBasic.trade + "Trade/tradeList";
      //   console.log(url)
      let pramas = {
        token: window.localStorage.getItem("xnwfPcToken"),
        current_page: 1,
        per_page: 1000
      };
      axios.post(url, pramas).then(res => {
        if (res.data.code == 200) {
          this.tradeList = res.data.data.data;
        }
        // console.log(res);
      });
    },
    downloadCost() {
      let pro = "";
      if (this.selectedThreeVal != "") {
        pro = this.selectedThreeVal;
      } else if (this.selectedTwoVal != "") {
        pro = this.selectedTwoVal;
      } else if (this.selectedOneVal != "") {
        pro = this.selectedOneVal;
      }
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Finance/listsProjectDownload?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&company_id=" +
        JSON.stringify(this.company_id) +
        "&customer_id=" +
        this.customer_id +
        "&time_type=" +
        this.time_type +
        "&start_date=" +
        this.start_date +
        "&end_date=" +
        this.end_date +
        "&status=" +
        this.status +
        "&project_id=" +
        pro +
        "&trade_id=" +
        this.trade_id;
    },
    selectedCost(item, key) {
      // console.log(item)
      this.bgIndex = key;
      this.proCostVal = item.project_name;
      this.proCostID = item.id;
      this.getCostList();
    },
    selectedOne(id) {
      this.isShowTwo = true;
      this.selectedTwoVal = "";
      this.selectedThreeVal = "";
      this.getProID(id, 1); //获取下级项目
      // console.log(id);
    },
    selectedTwo(id) {
      // this.isShowThree = true;
      this.selectedThreeVal = "";
      this.getProID(id, 2); //获取下级项目
    },
    getProOne() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/projectListByLevel";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          level: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListOne = res.data.data;
            // console.log(this.proList);
          }
        });
    },
    getProID(id, level) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/projectListByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            if (level == 1) {
              this.proListTwo = res.data.data;
            } else if (level == 2) {
              this.proListThree = res.data.data;
            }
            // console.log(this.proList);
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListThree = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    getCompany() {
      let url =
        this.httpsBasic.url + this.httpsBasic.customer + "Company/companyList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          per_page: 100000
        })
        .then(res => {
          if (res.data.code == 200) {
            this.comList = res.data.data.data;
            // console.log(this.comList);
          }
        });
    },
    getCustomer() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.customer +
        "Customer/customerList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          per_page: 100000
        })
        .then(res => {
          if (res.data.code == 200) {
            this.customerList = res.data.data.data;
          }
        });
    },
    onChange(pageNumber) {
      // console.log("Page: ", pageNumber);
      this.bgIndex = "";
      this.page = pageNumber;
      this.getData();
    },
    onChangeVal(pageNumber) {
      this.pageVal = pageNumber;
      this.getCostList();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    changeDate(date, dateString) {
      this.start_date = dateString[0];
      this.end_date = dateString[1];
      // console.log(dateString);
    },
    getData() {
      // console.log(this.$store.state.token);
      let pro = "";
      if (this.selectedThreeVal != "") {
        pro = this.selectedThreeVal;
      } else if (this.selectedTwoVal != "") {
        pro = this.selectedTwoVal;
      } else if (this.selectedOneVal != "") {
        pro = this.selectedOneVal;
      }
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url + this.httpsBasic.finance + "Finance/listsProject";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10000,
          query_field: this.query_field,
          project_id: pro,
          company_id: JSON.stringify(this.company_id),
          customer_id: this.customer_id,
          time_type: this.time_type,
          start_date: this.start_date,
          end_date: this.end_date,
          status: this.status,
          trade_id: this.trade_id,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            this.count_data = res.data.data.count_total;
            this.proCostVal = this.data[0].project_name;
            this.proCostID = this.data[0].id;
            this.getCostList();
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    getCostList() {
      let url = this.httpsBasic.url + this.httpsBasic.finance + "Finance/lists";
      axios
        .post(url, {
          current_page: this.pageVal,
          per_page: 100000,
          query_field: this.query_field,
          company_id: JSON.stringify(this.company_id),
          customer_id: this.customer_id,
          time_type: this.time_type,
          start_date: this.start_date,
          end_date: this.end_date,
          project_id: this.proCostID,
          status: this.status,
          // trade_id: this.trade_id,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.dataCost = res.data.data.data;
            this.loading = false;
            const pagination = { ...this.paginationVal };
            pagination.total = res.data.data.total;
            this.paginationVal = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    onReset() {
      this.type = "";
      this.project_id = "";
      this.company_id = [];
      this.customer_id = "";
      this.time_type = 1;
      this.selectedOneVal = "";
      this.selectedTwoVal = "";
      this.selectedThreeVal = "";
      this.status = "";
      this.proListTwo = [];
      this.proListThree = [];
      this.isShowTwo = false;
      this.start_date = "";
      this.end_date = "";
      this.trade_id = "";
      this.date = null;
      this.page = 1;
      this.getData();
      this.getPro();
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .tableStyles {
    border: 1px solid #e8e8e8;
  }
  .titleStyle {
    width: 100%;
    position: -webkit-sticky;
    position: sticky;
    top: 0;

    li {
      display: inline-block;
      width: 16.5%;
      background: #fafafa;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 500;
      border-bottom: 1px solid #e8e8e8;
      padding: 6px 12px;
      font-size: 12px;
      text-align: right;
    }
    li:nth-child(2),
    li:nth-child(3) {
      width: 16.5%;
    }
  }
  .contentStyle {
    width: 100%;
    > li {
      cursor: pointer;
      border-bottom: 1px solid #e8e8e8;
      p {
        display: inline-block;
        width: 16.5%;
        text-align: center;
        color: rgba(0, 0, 0, 0.65);
        padding: 6px 12px;
        font-size: 12px;
        text-align: right;
      }
      p:nth-child(2),
      p:nth-child(3) {
        width: 16.5%;
      }
    }

    > li:hover {
      background: #e3f8fe;
    }
  }

  tr {
    cursor: pointer;
  }
  .onChangeBackground {
    background: #e3f8fe;
  }
  .onRemoveBackground {
    background: #fff;
  }
  .searchBox {
    padding: 14px 2%;
    display: block;
    > span {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
    }
  }

  .tableStyles {
    height: 40vh;
    min-height: 40vh;
    overflow-y: scroll;
    padding: 0;
    margin: 0 2%;
  }
  .costStyle {
    height: 45vh;
    min-height: 45vh;
    .titleStyle {
      li {
        width: 10%;
      }
      li:nth-child(3),
      li:nth-child(4) {
        width: 15%;
      }
      li:nth-child(5) {
        width: 25%;
      }
      li:last-child {
        width: 15%;
      }
    }
    .contentStyle {
      li {
        p {
          width: 10%;
        }
        p:nth-child(3),
        p:nth-child(4) {
          width: 15%;
        }
        p:nth-child(5) {
          width: 25%;
        }
        p:last-child {
          width: 15%;
        }
      }
    }
  }
  .paginationOtherStyle {
    // justify-content: space-between;
    padding: 20px 2%;
    position: relative;
    > div {
      display: flex;
      flex-direction: row;
      align-items: center;

      ul {
        display: inline-block;
      }
    }
    > div:first-child {
      position: absolute;
      left: 2%;
      bottom: 10px;
      p {
        font-weight: bold;
      }
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
